import Formsy from 'formsy-react'
import isEmpty from 'lodash/isEmpty'
import React, { useState } from 'react'

import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import type { Fields as PointsExperience } from 'models/PointsExperience'

import MaximumPoints from './MaximumPoints'

type Props = {
  onClose: () => void
  isOpen: boolean
  pointsExperience: PointsExperience
  onSave?: (data: { max_points_per_transaction: number | null }) => void
}

export interface FormT extends PointsExperience {
  limit_points: boolean
  max_points_per_transaction: number | null
}

const t = buildTranslate('points.restrictions.restrictions_modal')

const Restrictions: React.FC<Props> = props => {
  const { onClose, isOpen, pointsExperience, onSave } = props
  const [formTemplate, setFormTemplate] = useState<FormT | null>({
    ...pointsExperience,
    limit_points: Boolean(pointsExperience.max_points_per_transaction),
    max_points_per_transaction: pointsExperience.max_points_per_transaction,
  })
  const currency = pointsExperience.currency_name_plural || ''

  const handleSave = () => {
    if (!isEmpty(formTemplate)) {
      const saveData = {
        max_points_per_transaction:
          formTemplate!.max_points_per_transaction || null,
      }
      if (onSave) {
        onSave(saveData)
      }
    }
    onClose()
  }

  const updateFormModel = (model: Partial<FormT>) => {
    setFormTemplate(prevModel =>
      prevModel ? { ...prevModel, ...model } : null
    )
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeType="small"
      size="auto"
      zIndex={1100}
    >
      <div className="fs-unmask w-100 p-xl" style={{ maxWidth: '800px' }}>
        <Text.Header3 color="grey90" className="mb-xs mt-xs">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 color="grey70" className="mb-xl" tag="p">
          {t('description')}
        </Text.BodyText3>
        <Formsy onChange={updateFormModel}>
          <MaximumPoints
            currency={currency}
            limitEnabled={formTemplate!.limit_points}
            maxPointsPerTransaction={formTemplate!.max_points_per_transaction}
            currencyIcon={pointsExperience.currency_primary_icon.default}
            onChange={(limit_points, max_points_per_transaction) =>
              setFormTemplate(prev =>
                prev
                  ? { ...prev, limit_points, max_points_per_transaction }
                  : null
              )
            }
          />
          <div className="d-flex justify-content-end mt-m">
            <Button className="mr-s" kind={Kind.SECONDARY} onClick={onClose}>
              {t('cancel')}
            </Button>
            <Button kind={Kind.PRIMARY} onClick={handleSave}>
              {t('save')}
            </Button>
          </div>
        </Formsy>
      </div>
    </Modal>
  )
}

export default Restrictions
